/**
 * Application configuration
 */

// API Configuration
export const API_CONFIG = {
  baseUrl: process.env.NODE_ENV === 'production' ? '' : 'https://applications-dev.netwalk.app',
  endpoints: {
    // Configuration endpoints
    getFormConfig: (formGuid) => `/api/configurations/form/${formGuid}`,
    getSiteConfig: (formGuid) => `/api/configurations/site/${formGuid}`,
    // Form submission
    submitForm: (formGuid) => `/api/submitform/${formGuid}`,
  },
};

// Cloudflare Turnstile Configuration
// Test keys from Cloudflare:
// - Always passes: 1x00000000000000000000AA
// - Always fails: 2x00000000000000000000AB
// - Forces interaction: 3x00000000000000000000FF
export const TURNSTILE_CONFIG = {
    enabled: true, // Set to false to disable Turnstile captcha
    siteKey: '0x4AAAAAACWwwmiseVBxag9V',
};
